var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlob({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 644,
    height: 611,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A996FF",
    fillRule: "evenodd",
    d: "M341.497.188c87.956-2.828 176.014 26.144 233.031 93.443 59.159 69.828 83.593 165.123 61.357 254.035-21.703 86.785-94.117 144.226-171.886 187.93-86.481 48.601-182.863 98.973-275.441 63.457C88.868 560.808 14.863 464.426 1.421 358.135c-12.312-97.356 57.574-179.082 125.042-250.095C184.647 46.798 257.242 2.898 341.497.188Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob);
export default __webpack_public_path__ + "static/media/blob.8361800d544da3e869c86e92905d9172.svg";
export { ForwardRef as ReactComponent };